import React from "react"
import { componentStyles, useColors } from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSparkles } from "@fortawesome/pro-solid-svg-icons/faSparkles"

interface Props {
    readonly size?: number
    readonly isBrandColor?: boolean
}

export default function SparkleIcon({ size = 16, isBrandColor }: Props) {
    const styles = useStyles({ size, isBrandColor })

    return <FontAwesomeIcon icon={faSparkles} style={styles.root} />
}

function useStyles({ size = 16, isBrandColor }: Props) {
    const colors = useColors()
    const color = isBrandColor ? colors.brandDefault : "currentColor"

    return componentStyles({ root: { width: size, height: "auto", color } })
}
